module.exports = __webpack_public_path__ + "img/biotechnology-careers.8bbaf04f.jpg";